module.exports = __webpack_public_path__ + "img/luna-blue.64a9b19a.png";